<script>
  import ContratoService from '../../../../domain/contrato/services/contrato'
  import ContaBancariaService from '../../../../domain/conta-bancaria/services/conta-bancaria'
  import CategoriasVeicularesService from '../../../../domain/bem-categoria/services/categorias-veiculares'
  import { isArray } from 'lodash'
  import estadosBr from '../../../_default/utils/estados-brasileiros'
  import { VueMaskDirective as mask } from 'v-mask'
  import {REAL_BRL} from '../../../../utils/helpers/money'
  import { VMoney } from 'v-money'
  import PopupViewer from '../../../_default/components/popup-viewer/PopupViewer'
  import {number_format as numberFormat} from '../../../../utils/helpers/phpjs'

  const CATEGORIA_CONTRATO_MODEL = {
    valorDiaria: 0.0,
    valorHoraServicoAdicional: 0.0,
    valorKmAdicional: 0.0,
    valorReboque: 0.0,
    bemCategoria: null
  }

  export default {
    nome: 'novo-contrato',
    components: {
      PopupViewer,
      CadastroContaBancaria: () => import('../../conta-bancaria/components/NovoContaBancaria'),
      CadastroCategoriaVeicular: () => import('../../categorias-veiculares/components/NovaCategoria')
    },
    directives: {mask, money: VMoney},
    data () {
      return {
        money: REAL_BRL,
        isLoading: false,
        isLoaded: false,
        cadastroError: null,
        atualizadoSucesso: null,
        data: {
          id: null,
          nome: '',
          descontoFimDeSemana: false,
          descontoFeriado: false,
          limiteDiarias: 0,
          cobrarTaxaBancaria: false,
          valorKmForaDaCidade: 0.0,
          usaGgv: false,
          contaBancaria: null,
          categoriasContratos: [
            {...CATEGORIA_CONTRATO_MODEL}
          ]
        },
        contasBancarias: null,
        categoriasVeiculares: null,
        showCadastroContaBancaria: false,
        showCadastroCategoriaVeicular: false
      }
    },
    computed: {
      estadosBr () {
        return estadosBr
      }
    },
    created () {
      this.loadContasBancarias()
      this.loadCategoriasVeiculares()
    },
    mounted () {
      this.start()
    },
    activated () {
    },
    destroyed () {
    },
    watch: {},
    methods: {
      start () {
        if (this.$route.params.id) {
          this.$loaderOverlay.open().message('Carregando')
          ContratoService.find(this.$route.params.id)
            .then((response) => {
              this.isLoaded = true
              this.$loaderOverlay.hide()
              this.data = response.data
              // TODO: GAMBIARRA; VERIFICAR SE HÁ MELHOR FORMA
              this.data.contaBancaria = this.data.contaBancaria && this.data.contaBancaria.id || null
              this.data.categoriasContratos = response.data.categoriasContratos.map(item => {
                item.bemCategoria = item.bemCategoria.id
                item.valorDiaria = numberFormat(item.valorDiaria, 2, ',', '.')
                item.valorHoraServicoAdicional = numberFormat(item.valorHoraServicoAdicional, 2, ',', '.')
                item.valorKmAdicional = numberFormat(item.valorKmAdicional, 2, ',', '.')
                item.valorReboque = numberFormat(item.valorReboque, 2, ',', '.')
                return item
              })
              console.log(this.data.categoriasContratos)
              console.log(response)
            })
            .catch((response) => {
              this.$loaderOverlay.hide()
              console.log(response)
            })
        } else {
          this.isLoaded = true
          // this.$loaderOverlay.open().message('Aguarde')
        }
      },
      submit () {
        this.cadastroError = null
        this.atualizadoSucesso = false
        this.$loaderOverlay.open().message('Processando...')
        this.$bar.start()
        window.setTimeout(() => {
          this.$loaderOverlay.message('Aguarde...')
        }, 1000)
        const request = this.prepararDados()
        ContratoService.cadastrar(request, this.$route.params.id).then((response) => {
          let callbackEnd = () => {
            this.$bar.finish()
            this.$loaderOverlay.hide()
            if (this.$route.params.id) {
              // Continua na mesma tela de edição
              // this.$nextTick(() => {
              this.start()
              this.atualizadoSucesso = true
              this.$el.querySelector('#sucessMsg').focus()
              // })
            } else {
              // Redirecionr para tela de visualização
              // this.$router.push({name: 'documento.editar', params: {id: response.data.id}})
              this.atualizadoSucesso = true
            }
          }
          callbackEnd()
        }).catch((response) => {
          this.$bar.finish()
          this.$loaderOverlay.hide()
          this.cadastroError = response.data.errors
          this.$nextTick(() => {
            this.$refs.error.focus()
          })
          console.log(response)
        })
      },
      prepararDados () {
        // const clearNumber = str => str.replace(/\D/g, '')
        const convertMoneyToFloat = str => +str.replace(/^\D*/, '').replace(/\./, '').replace(/,/, '.')
        const tmp = {...this.data}
        tmp.valorKmForaDaCidade = convertMoneyToFloat(tmp.valorKmForaDaCidade)
        tmp.categoriasContratos = tmp.categoriasContratos.map(item => ({
          valorDiaria: convertMoneyToFloat(item.valorDiaria),
          valorHoraServicoAdicional: convertMoneyToFloat(item.valorHoraServicoAdicional),
          valorKmAdicional: convertMoneyToFloat(item.valorKmAdicional),
          valorReboque: convertMoneyToFloat(item.valorReboque),
          bemCategoria: item.bemCategoria
        }))
        return {...tmp}
      },
      loadContasBancarias () {
        ContaBancariaService.list(100000, 1, '')
          .then(result => {
            this.contasBancarias = result.data.result
            console.log(this.contasBancarias)
          })
          .catch(error => {
            console.log(error)
          })
      },
      loadCategoriasVeiculares () {
        CategoriasVeicularesService.list(100000, 1, '')
          .then(result => {
            this.categoriasVeiculares = result.data.result
            console.log(this.categoriasVeiculares)
          })
          .catch(error => {
            console.log(error)
          })
      },
      addValorCategoria () {
        this.data.categoriasContratos.push({...CATEGORIA_CONTRATO_MODEL})
      },
      removeValorCategoria (index) {
        if (window.confirm('Tem certeza de que deseja remover os valores para essa categoria?')) {
          this.data.categoriasContratos.splice(index, 1)
        }
      },
      closeCadastroContaBancaria () {
        this.showCadastroContaBancaria = false
        this.loadContasBancarias()
      },
      closeCadastroCategoriaVeicular () {
        this.showCadastroCategoriaVeicular = false
        this.loadCategoriasVeiculares()
      },
      printError (err) {
        if (isArray(err)) {
          return err[0]
        }
        return err
      }
    }
  }
</script>

<template>
  <transition name="slide">
    <div v-if="isLoaded" class="content-transition">
      <div class="bg-light lter b-b wrapper-md">
        <div class="row">
          <div class="col-sm-6"><h1 class="m-n font-thin h3">Cadastro de Contrato</h1></div>
          <div class="col-sm-6">
            <router-link :to="{name: 'config.contratos.list'}"
                         class="pull-right hidden-print" style="clear: left"><strong class="label no-radius bg-info">Voltar</strong>
            </router-link>
          </div>
        </div>
      </div>
      <div class="wrapper-md">
        <div class="panel panel-default">
          <div class="panel-body">
            <div tabindex="-1" ref="error" v-if="cadastroError !== null" class="alert alert-danger">
              <div class="m-b-sm font-bold">Erro ao registrar, corrija e tente novamente</div>
              <p v-for="(erro, key) in cadastroError">{{printError(erro)}}</p>
            </div>
            <a name="sucessMsg" id="sucessMsg" href="javascript:void(0)" ref="sucessMsg"></a>
            <div tabindex="-1" ref="error" v-if="atualizadoSucesso !== null && atualizadoSucesso" class="alert alert-success">
              <div class="font-bold">{{$route.params.id && 'Atualizado' || 'Cadastrado'}} com sucesso!</div>
            </div>
            <form @submit.prevent.stop="" class="bs-example form-horizontal">

              <div class="form-group">
                <label class="col-sm-4 control-label">Nome</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" v-model="data.nome" required/>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-4 control-label">Conta Bancária</label>
                <div class="col-sm-8">
                  <span v-if="!contasBancarias">Carregando...</span>
                  <select class="form-control" v-model="data.contaBancaria" v-else>
                    <option :value="null" disabled>Selecione</option>
                    <option :value="conta.id" v-for="conta in contasBancarias" :key="conta.id">{{conta.nomeBanco}}</option>
                  </select>
                  <div>
                    <u-button class="btn btn-default btn-xs m-t-xs" @click="showCadastroContaBancaria = true">
                      <i class="fa fa-plus"></i> Cadastrar nova conta bancária
                    </u-button>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label for="cobrar-taxa-bancaria" class="col-sm-4 control-label">Cobrar Taxa Bancária</label>
                <div class="col-sm-8">
                  <input type="checkbox" id="cobrar-taxa-bancaria" v-model="data.cobrarTaxaBancaria"/>
                </div>
              </div>

              <div class="form-group">
                <label for="desconto-fim-semana" class="col-sm-4 control-label">Possui Desconto no Fim de Semana</label>
                <div class="col-sm-8">
                  <input type="checkbox" id="desconto-fim-semana" v-model="data.descontoFimDeSemana"/>
                </div>
              </div>

              <div class="form-group">
                <label for="desconto-feriado" class="col-sm-4 control-label">Possui Desconto em Feriados</label>
                <div class="col-sm-8">
                  <input type="checkbox" id="desconto-feriado" v-model="data.descontoFeriado"/>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-4 control-label">Quantidade máxima de diárias</label>
                <div class="col-sm-8">
                  <input type="number" class="form-control" v-model="data.limiteDiarias"/>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-4 control-label">Valor do Km Fora da Cidade</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" v-model="data.valorKmForaDaCidade" v-money="money"/>
                </div>
              </div>

              <div class="form-group">
                <label for="usa-ggv" class="col-sm-4 control-label">Usa controle de Guia de Guarda Veicular (GGV)</label>
                <div class="col-sm-8">
                  <input id="usa-ggv" type="checkbox" v-model="data.usaGgv"/>
                </div>
              </div>

              <div class="table-responsive">
                <table class="table table-hover table-striped b-t b-light">
                  <thead>
                  <tr>
                    <th>Categoria</th>
                    <th>Valor para Reboque</th>
                    <th>Valor para Diária</th>
                    <th>Valor Km Adicional</th>
                    <th>Valor Hora de Serviço Adicional</th>
                    <th></th>
                  </tr>
                  </thead>
                  <tbody>
                  <!-- FAKE -->
                  <tr v-if="!data.categoriasContratos" v-for="i in [1,2,3]">
                    <td role="button" tabindex="0">
                      <u-fake-loader width="100%" class="m-t"></u-fake-loader>
                    </td>
                    <td class="v-middle">
                      <u-fake-loader width="20px" class="m-t"></u-fake-loader>
                    </td>
                    <td role="button" tabindex="0">
                      <u-fake-loader width="100%" class="m-t"></u-fake-loader>
                    </td>
                    <td class="v-middle">
                      <u-fake-loader width="20px" class="m-t"></u-fake-loader>
                    </td>
                    <td role="button" tabindex="0">
                      <u-fake-loader width="100%" class="m-t"></u-fake-loader>
                    </td>
                  </tr>
                  <tr v-for="(contratoCategoria, index) in data.categoriasContratos">
                    <td>
                      <div class="form-group">
                        <div class="col-sm-12">
                          <span v-if="!data.categoriasContratos">Carregando...</span>
                          <select class="form-control" v-model="contratoCategoria.bemCategoria" v-else>
                            <option :value="null" disabled>Selecione</option>
                            <option :value="categoria.id" v-for="categoria in categoriasVeiculares" :key="categoria.id">
                              {{categoria.nome}}
                            </option>
                          </select>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="form-group">
                        <div class="col-sm-8">
                          <input type="text" class="form-control" v-model="contratoCategoria.valorReboque" v-money="money"/>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="form-group">
                        <div class="col-sm-8">
                          <input type="text" class="form-control" v-model="contratoCategoria.valorDiaria" v-money="money"/>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="form-group">
                        <div class="col-sm-8">
                          <input type="text" class="form-control" v-model="contratoCategoria.valorKmAdicional" v-money="money"/>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="form-group">
                        <div class="col-sm-8">
                          <input type="text" class="form-control" v-model="contratoCategoria.valorHoraServicoAdicional" v-money="money"/>
                        </div>
                      </div>
                    </td>
                    <td>
                      <u-button class="btn btn-danger btn-sm" title="Excluir" @click="removeValorCategoria(index)">
                        <i class="fa fa-trash"></i>
                      </u-button>
                    </td>
                  </tr>

                  <tr v-if="data.categoriasContratos && data.categoriasContratos.length === 0">
                    <td colspan="6">Nenhum registro encontrado</td>
                  </tr>

                  </tbody>
                </table>
                <u-button class="btn btn-default btn-sm" @click="addValorCategoria">
                  <i class="fa fa-plus"></i> Adicionar valor de categoria
                </u-button>
                <u-button class="btn btn-default btn-sm" @click="showCadastroCategoriaVeicular = true">
                  <i class="fa fa-plus"></i> Cadastrar nova categoria veicular
                </u-button>
              </div>

              <div class="clearfix"></div>

              <hr>
              <div class="row wrapper">
                <u-button @click="submit" class="btn m-b-xs w-xs btn-info m-r-xs">
                  <span v-if="!data.id">Cadastrar</span>
                  <span v-if="data.id">Atualizar</span>
                </u-button>
                <u-button class="btn m-b-xs w-xs m-r-xs btn-default" @click="$router.push({name: 'config.contratos.list'})">Cancelar</u-button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <popup-viewer @close="closeCadastroContaBancaria" v-if="showCadastroContaBancaria" title="Cadastro de conta bancária">
        <CadastroContaBancaria @finishSubmit="closeCadastroContaBancaria" @cancel="showCadastroContaBancaria = false" viewer-mode/>
      </popup-viewer>
      <popup-viewer @close="closeCadastroCategoriaVeicular" v-if="showCadastroCategoriaVeicular" title="Cadastro de categoria veicular">
        <CadastroCategoriaVeicular @finishSubmit="closeCadastroCategoriaVeicular" @cancel="showCadastroCategoriaVeicular = false" viewer-mode />
      </popup-viewer>
    </div>
  </transition>
</template>



// WEBPACK FOOTER //
// NovoContrato.vue?536827af